import React from "react";
import { useTranslation } from "react-i18next";
import PostingForm from "app/components/PostingForm";
import PostModel, { PostingModel } from "app/models/PostModel";
import { usePostingFormBase } from "app/utils/hooks/usePostingFormBase";
import usePlanFeature from "app/utils/services/plan_feature/user";

interface Props {
  templateId: string;
  onPost?: (_post: PostModel) => void;
}

const WorkflowPostingForm = ({ templateId, onPost }: Props) => {
  const { t } = useTranslation();
  const { user, canUploadMedia, postActions } = usePostingFormBase();
  const { canSchedulePosts } = usePlanFeature(user);

  const onSubmit = (data: PostingModel) => {
    if (templateId) {
      postActions
        .createPost({ ...data, space_template_id: templateId })
        .then((res: PostModel) => {
          if (onPost) {
            onPost({ ...res, userAvatar: user?.avatar });
          }
        });
    }
  };

  return (
    <PostingForm
      textAreaPlaceholder={t("Create post...")}
      canUploadMedia={canUploadMedia()}
      canSchedule={canSchedulePosts}
      profilePicture={null}
      postButtonLabel={t("Post")}
      postTextIsRequired
      hasLocationSelect={false}
      onPost={onSubmit}
      scheduledInActive
    />
  );
};

export default WorkflowPostingForm;
